import { gql } from '@apollo/client';

export const DeleteGuestUserAccess = gql`
  mutation DeleteGuestUserAccess($organizationCode: String!, $personIdentifiers: [String], $filter: String) {
    deleteGuestUserAccess(organizationCode: $organizationCode, personIdentifiers: $personIdentifiers, filter: $filter)
  }
`;
